var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "nodeElement",
      staticClass: "cf-node",
      class: [
        `cf-node--${_vm.node.nodeTypeId}`,
        _vm.node.nodeOptions.size
          ? `cf-node--${_vm.node.nodeOptions.size}`
          : "",
        _vm.isNodeSelected ? "cf-node--selected" : "",
        _vm.hasErrors ? "error" : "",
        _vm.isValidGoToNode ? "cf-node--available-goto" : ""
      ],
      style: _vm.nodeStyles,
      on: {
        contextmenu: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
        }
      }
    },
    [
      _vm._l(_vm.node.inputs, function(slot, index) {
        return _c(
          "div",
          {
            key: index,
            class: { "cf-node__drop-zone": _vm.enableDropzone },
            on: {
              mouseup: function($event) {
                $event.stopPropagation()
                return _vm.endConnection($event, index)
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "cf-node__input", class: { active: slot.active } },
              [
                slot.active
                  ? _c(
                      "button",
                      {
                        staticClass: "cf-node__input-remove-link",
                        on: { click: _vm.removeConnection }
                      },
                      [_c("i", { staticClass: "fa fa-times" })]
                    )
                  : _vm._e()
              ]
            )
          ]
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cf-node__main",
          on: {
            mousemove: _vm.handleMove,
            touchmove: _vm.handleMove,
            mousedown: _vm.handleDown,
            touchstart: _vm.handleDown,
            mouseup: _vm.handleUp,
            touchend: _vm.handleUp
          }
        },
        [
          _c("div", { staticClass: "cf-node__header" }, [
            _vm.nodeNameTrimmed
              ? _c(
                  "div",
                  {
                    staticClass: "cf-node__display-name",
                    class: [
                      { extended: _vm.nodeNameLengthProps.extended },
                      { overflow: _vm.nodeNameLengthProps.overflow }
                    ],
                    attrs: { title: _vm.nodeNameTrimmed }
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.nodeNameTrimmed) + "\n      "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.top",
                  value: _vm.node.nodeDescription,
                  expression: "node.nodeDescription",
                  modifiers: { top: true }
                }
              ],
              staticClass: "cf-node__icon m-r-6",
              class: _vm.node.nodeOptions.icon,
              style: _vm.nodeIconStyle,
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cf-node__title" },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.node.displayName) + "\n        "
                ),
                _vm.isVoiceResponseEnabledGatherNode
                  ? _c("img", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: _vm.$t("VOICE_RESPONSE_ENABLED"),
                          expression: "$t('VOICE_RESPONSE_ENABLED')",
                          modifiers: { top: true }
                        }
                      ],
                      staticClass: "width-1em m-l-6",
                      attrs: {
                        src: require("@/assets/icons/voiceEnabledGatherNodeWhite.svg"),
                        alt: ""
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasErrors
                  ? _c("i", {
                      ref: "invalidBadge",
                      staticClass: "fa fa-warning error m-l-6",
                      attrs: { "aria-hidden": "true" },
                      on: {
                        mousedown: function($event) {
                          $event.stopPropagation()
                        },
                        mouseup: function($event) {
                          $event.stopPropagation()
                          return _vm.toggleErrors.apply(null, arguments)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasErrors && _vm.showErrors
                  ? _c(
                      "Popover",
                      {
                        directives: [
                          {
                            name: "click-outside",
                            rawName: "v-click-outside",
                            value: {
                              binding: _vm.toggleErrors,
                              focus: ".popover"
                            },
                            expression:
                              "{ binding: toggleErrors, focus: '.popover' }"
                          }
                        ],
                        attrs: {
                          placement: "right",
                          trigger: "manual",
                          "custom-class": "cf-node__error-popover",
                          target: _vm.popoverTrigger
                        },
                        model: {
                          value: _vm.showErrors,
                          callback: function($$v) {
                            _vm.showErrors = $$v
                          },
                          expression: "showErrors"
                        }
                      },
                      [
                        _c("template", { slot: "popover" }, [
                          _c(
                            "ul",
                            [
                              _vm.generalErrors && _vm.generalErrors.length
                                ? _vm._l(_vm.generalErrors, function(
                                    error,
                                    index
                                  ) {
                                    return _c(
                                      "li",
                                      { key: `'gen-error-'${index}` },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(error) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.propertyErrors && _vm.propertyErrors.length
                                ? _vm._l(_vm.propertyErrors, function(
                                    error,
                                    index
                                  ) {
                                    return _c(
                                      "li",
                                      { key: `'prop-error-${index}` },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm._f("camelCaseFormat")(
                                                error.propertyName
                                              )
                                            ) +
                                            "\n                  " +
                                            _vm._s(error.errorMessage) +
                                            ".\n                "
                                        )
                                      ]
                                    )
                                  })
                                : _vm._e()
                            ],
                            2
                          )
                        ])
                      ],
                      2
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            !_vm.isRootNode
              ? _c("div", { staticClass: "cf-node__actions" }, [
                  _vm.playUrl
                    ? _c(
                        "div",
                        {
                          staticClass: "cf-node__action m-l-4",
                          on: {
                            mousedown: function($event) {
                              $event.stopPropagation()
                            },
                            mouseup: function($event) {
                              $event.stopPropagation()
                            }
                          }
                        },
                        [
                          _c("RecordingButton", {
                            attrs: {
                              "recording-url": _vm.playUrl,
                              "fixed-player": ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "cf-node__action cf-node__action-delete m-l-8 m-b-2",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.deleteNode.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-trash cf-node__action-delete",
                        attrs: { "aria-hidden": "true" }
                      })
                    ]
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.node.outputs && _vm.node.outputs.length
            ? _c(
                "div",
                { staticClass: "cf-node__outputs" },
                _vm._l(_vm.node.outputs, function(output, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "cf-node__output" },
                    [
                      _vm._v("\n        " + _vm._s(output.name) + "\n        "),
                      _c("i", {
                        staticClass: "fa fa-square cf-node__output-start",
                        on: {
                          mousedown: function($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.startConnection(index, output, $event)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.showNodeAdd(index)
                        ? _c(
                            "span",
                            {
                              staticClass: "cf-node__output-add",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.showContextMenu($event, {
                                    node: _vm.node,
                                    index,
                                    output
                                  })
                                }
                              }
                            },
                            [_vm._v("+")]
                          )
                        : _vm._e()
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.node.nodeType === "Unavailable"
            ? _c(
                "div",
                { staticClass: "cf-node__message" },
                [
                  _c("i18n", {
                    attrs: { path: "UNAVAILABLE_NODE", tag: "p" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "unavailableNodeName",
                          fn: function() {
                            return [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.unavailableNodeName))
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      4280074708
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "cf-node__select-node" }, [
        _vm.isValidGoToNode
          ? _c(
              "div",
              {
                on: {
                  click: function($event) {
                    return _vm.selectNode($event)
                  }
                }
              },
              [
                _c("i", {
                  staticClass: "fa fa-crosshairs",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            )
          : _c("div")
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }